const DATE_GROUP_DEFS = [
  { key: 'today', label: 'Today' },
  { key: 'yesterday', label: 'Yesterday' },
  { key: 'week', label: 'This week' },
  { key: 'older', label: 'Older' },
];

function startOfLocalDay(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function dateBucket(createdOn, now = new Date()) {
  const t = new Date(createdOn).getTime();
  if (!Number.isFinite(t)) return 'older';
  const today = startOfLocalDay(now);
  const msgDay = startOfLocalDay(new Date(t));
  if (msgDay.getTime() === today.getTime()) return 'today';
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  if (msgDay.getTime() === yesterday.getTime()) return 'yesterday';
  const weekStart = new Date(today);
  weekStart.setDate(weekStart.getDate() - weekStart.getDay());
  weekStart.setHours(0, 0, 0, 0);
  if (msgDay.getTime() >= weekStart.getTime()) return 'week';
  return 'older';
}

function dateGroupCollapsedByDefault(key) {
  return key === 'week' || key === 'older';
}

function groupByDate(list, now = new Date(), getDate) {
  const pick =
    typeof getDate === 'function' ? getDate : (row) => row && row.createdOn;
  const groups = DATE_GROUP_DEFS.map((def) => ({
    key: def.key,
    label: def.label,
    items: [],
  }));
  const byKey = Object.fromEntries(groups.map((g) => [g.key, g]));
  for (const row of Array.isArray(list) ? list : []) {
    const key = dateBucket(pick(row), now);
    byKey[key].items.push(row);
  }
  return groups.filter((g) => g.items.length > 0);
}

module.exports = {
  DATE_GROUP_DEFS,
  dateBucket,
  dateGroupCollapsedByDefault,
  groupByDate,
};
